export default __webpack_public_path__ + "50a901751a95795fb3b167d75511a9b4.png";